// import React from 'react';

// interface PlaceHolderAmbulanceProps {
//   ambulanceName: string;

// }

// const PlaceHolderAmbulance = ({ ambulanceName }: PlaceHolderAmbulanceProps) => {
//   return (
//     <div className="border p-3 bg-db-border bg-white dark:bg-bg-grey-dark rounded-[12px]">
//       <span className="title2 text-text-grey uppercase">{ambulanceName}</span>
//       <div className="mt-2 border p-3 border-dashed rounded-[12px] title2 text-center text-text-grey  border-text-blue-50  bg-[#F3F6FE] ">
//         <span>Select an ambulance from the list </span>
//       </div>
//     </div>
//   );
// };

// export default PlaceHolderAmbulance;

import { XCircle } from 'lucide-react';
import React from 'react';
import { useTranslation } from 'react-i18next';
import Button from '@/shared/components/ui/Button';

interface PlaceHolderAmbulanceProps {
  ambulanceName: string;

  selected?: boolean;

  plateNumber?: string;
  hospital?: string;

  onRemove?: () => void;
  onRequest?: () => void;
  onRemovePlaceolder?: () => void;
  showRemove?: boolean;
  isRequesting?: boolean;
  isRequested?: boolean;
}

const PlaceHolderAmbulance = ({
  ambulanceName,
  selected = false,
  plateNumber,
  showRemove = false,
  hospital,
  onRemove,
  onRequest,
  onRemovePlaceolder,
  isRequesting = false,
  isRequested = false,
}: PlaceHolderAmbulanceProps) => {
  const { t } = useTranslation();

  return (
    <div className="rounded-[12px] border bg-white p-3 dark:bg-bg-grey-dark">
      <div className="w-full flex flex-row justify-between gap-3">
        <span className="title2 uppercase text-text-grey dark:text-white">{ambulanceName}</span>
        {showRemove && (
          <button type="button" onClick={onRemovePlaceolder}>
            <XCircle
              size={22}
              className="text-text-grey ml-auto dark:text-white hover:text-red-500 transition-colors"
            />
          </button>
        )}
      </div>
      {selected ? (
        <div className="w-full flex flex-col gap-[10px]">
          <div className="mt-2 gap-3 justify-between flex flex-row items-center rounded-[12px] border border-text-blue-100 bg-db-wrap p-3">
            <div className="flex flex-col items-start justify-between">
              <span className="text-db-text dark:text-white   title1medium py-1 px-2 border rounded-[4px] dark:bg-[#F3F6FE]/10 bg-[#F3F6FE] ">
                {plateNumber}
              </span>
              <span className=" title2 text-text-grey dark:text-white">{hospital}</span>
            </div>
            <button type="button" onClick={onRemove}>
              <XCircle
                size={22}
                className="text-text-grey dark:text-white hover:text-red-500 transition-colors"
              />
            </button>
          </div>

          <Button
            onClick={onRequest}
            variant="default"
            disabled={isRequesting || isRequested}
            className="w-full  btn-fill-blue capitalize disabled:opacity-50"
          >
            <span className="title1">
              {isRequested
                ? t('dispatch>master>dispatch requested')
                : t('dispatch>master>request dispatch')}
            </span>
          </Button>
        </div>
      ) : (
        <div className="mt-2 rounded-[12px] border border-dashed border-text-blue-50 bg-db-wrap p-3 text-center">
          <span className="title2 text-text-grey dark:text-white">
            {t('cm > select ambulance from list')}
          </span>
        </div>
      )}
    </div>
  );
};

export default PlaceHolderAmbulance;
